module.exports = "/images/premium-agent-shield.png?fae28cc7975dcf299360b59c5386fa69";